angular.module('impactx.search').controller('ListPaneCtrl', [
    ListPaneController
]);

function ListPaneController() {
    var self = this;

    self.$onInit = function () {
        self.containerCtrl.addPane(self);
    };
}